export const QUEST_CONTENT_MAX_SIZE = 2048;

export const QUESTION_CATEGORY_VISIBILITY_NEVER = 0,
    QUESTION_CATEGORY_VISIBILITY_ALWAYS = 1,
    QUESTION_CATEGORY_VISIBILITY_SUBSCRIBED = 2;

export const QUESTION_CATEGORY_SUBSCRIBE_POLICY_EVERYONE = 1,
    QUESTION_CATEGORY_SUBSCRIBE_POLICY_MODERATED = 2;
